import { z } from "zod";

/** Structured address for POST /geocode when not using a magicKey. */
export const GeocodeStructuredAddressSchema = z.object({
	Street1: z.string(),
	Street2: z.string().optional().default(""),
	City: z.string(),
	State: z.string(),
	Country: z.string(),
	PostalCode: z.string(),
});

export type GeocodeStructuredAddress = z.infer<
	typeof GeocodeStructuredAddressSchema
>;

export const GeocodeSuggestRequestSchema = z.object({
	address: z.string(),
	latitude: z.number().optional(),
	longitude: z.number().optional(),
	maxSuggestions: z.number().int().positive().optional(),
	countryCode: z.string().optional(),
});

export type GeocodeSuggestRequest = z.infer<typeof GeocodeSuggestRequestSchema>;

export const GeocodeSuggestionDtoSchema = z.object({
	text: z.string(),
	magicKey: z.string(),
	isCollection: z.boolean(),
});

export const GeocodeSuggestResponseSchema = z.object({
	response: z.object({
		suggestions: z.array(GeocodeSuggestionDtoSchema),
	}),
	statusCode: z.number(),
	isSuccessStatusCode: z.boolean(),
});

export type GeocodeSuggestResponse = z.infer<
	typeof GeocodeSuggestResponseSchema
>;

/** Normalized suggestion returned by GeocodeService.suggestAddress. */
export interface GeocodeSuggestion {
	id: string;
	primary: string;
	magicKey: string;
	isCollection: boolean;
}

export const GeocodeRequestSchema = z.object({
	address: GeocodeStructuredAddressSchema.optional(),
	magicKey: z.string().optional(),
	countryCode: z.string().optional(),
});

export type GeocodeRequest = z.infer<typeof GeocodeRequestSchema>;

export const GeocodeResultSchema = z.object({
	latitude: z.number(),
	longitude: z.number(),
	formattedAddress: z.string().nullable().optional(),
	score: z.number().nullable().optional(),
	statusCode: z.number(),
	isSuccessStatusCode: z.boolean(),
});

export type GeocodeResult = z.infer<typeof GeocodeResultSchema>;
